/* eslint-disable no-console */
import React from 'react';
import Chart from 'react-apexcharts';

const ApexBarChart = (props) => {
  const {barChartData, feedName} = props;
  const value=[];
  const keys = [];
  Object.keys(barChartData).map(k => {
    if(k!=='LowCCPP'){
      keys.push(k);
      value.push(barChartData[k]);
    }
  });
  const data = value;
  const options = {
    series: [
      {
        name: 'Saturation',
        data
      }
    ],
    chart: {
      type: 'bar',
      parentHeightOffset: 0,
    },
    plotOptions: {
      bar: {
        borderRadius: 5,
        columnWidth: '70%',
        distributed: feedName ==='CLRO',
        dataLabels: {
          position: 'top' // top, center, bottom
        }
      }
    },
    noData: {
      text: 'No Data',
      align: 'center',
      verticalAlign: 'middle',
      offsetX: 0,
      offsetY: 0,
      style: {
        fontSize: '12px',
      }
    },
    dataLabels: {
      enabled: true,
      style: {
        fontSize: '12px',
        colors: ['#333']
      },
      formatter (val) {
        if(Number(val).toFixed(0)==='0'){
          return '';
        }
        return `${Number(val).toFixed(1)  }`;
      },
      offsetY: -20
    },
    grid: {
      row: {
        colors: ['#fff', '#f2f2f2']
      }
    },
    legend: {
      show: false
    },
    xaxis: {
      labels: {
        rotate: -45
      },
      categories: keys,
      tickPlacement: 'on',
    },
    yaxis: {
      title: {
        text: '% Saturation'
      },
      min: 0,
      max: feedName ==='CLRO'?180:140,
      tickAmount: 7,
      labels: {
        formatter (val) {
          if(Number(val).toFixed(0)==='0'){
            return '';
          }
          return `${Number(val).toFixed(1)  }`;
        },
      }
    },
    tooltip: {
      marker: {
        show: true,
      }
    },
    fill: {
      colors: feedName ==='CLRO'?[
        ({ value})=> {
          if (value > 100) {
            return '#f34428';
          } if (value > 80 && value <= 100) {
            return '#FFBF00';
          }
          return '#8bc63e';
        },
        ({ value})=> {
          if (value > 120) {
            return '#f34428';
          } if (value > 100 && value <= 120) {
            return '#FFBF00';
          }
          return '#8bc63e';
        },
        ({ value})=> {
          if (value > 120) {
            return '#f34428';
          } if (value > 100 && value <= 120) {
            return '#FFBF00';
          }
          return '#8bc63e';
        },
        ({ value})=> {
          if (value > 120) {
            return '#f34428';
          } if (value > 100 && value <= 120) {
            return '#FFBF00';
          }
          return '#8bc63e';
        },
        ({ value})=> {
          if (value > 120) {
            return '#f34428';
          } if (value > 100 && value <= 120) {
            return '#FFBF00';
          }
          return '#8bc63e';
        },
        ({ value})=> {
          if (value > 120) {
            return '#f34428';
          } if (value > 100 && value <= 120) {
            return '#FFBF00';
          }
          return '#8bc63e';
        },
        ({ value})=> {
          if (value > 120) {
            return '#f34428';
          } if (value > 100 && value <= 120) {
            return '#FFBF00';
          }
          return '#8bc63e';
        },
        ({ value})=> {
          if (value > 120) {
            return '#f34428';
          } if (value > 100 && value <= 120) {
            return '#FFBF00';
          }
          return '#8bc63e';
        },
        ({ value})=> {
          if (value > 140) {
            return '#f34428';
          } if (value > 115 && value <= 140) {
            return '#FFBF00';
          }
          return '#8bc63e';
        },
        ({ value})=> {
          if (value > 120) {
            return '#f34428';
          } if (value > 100 && value <= 120) {
            return '#FFBF00';
          }
          return '#8bc63e';
        },
      ] : [({ value})=> {
        if (value > 100) {
          return '#f34428';
        } if (value > 80 && value <= 100) {
          return '#FFBF00';
        }
        return '#8bc63e';
      }],

      type: 'gradient',
      gradient: {
        shade: 'light',
        type: 'horizontal',
        shadeIntensity: 0.15,
        gradientToColors: undefined,
        inverseColors: true,
        opacityFrom: 0.76,
        opacityTo: 0.85,
        stops: [50, 0, 100],
        colorStops: []
      }
    }
  };
  return (
    <Chart options={options} series={options.series} type="bar" width="100%" height='210'/>
  );
};
export default ApexBarChart;